export default __webpack_public_path__ + "static/media/support-hero.906d905c.svg";